import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { get, isEmpty } from 'lodash';
import DynamicForm from 'screens/common/dynamicForm';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useParams } from 'react-router-dom';
import { cultivationApi } from 'api/endpoints/Cultivation';
import { toast } from 'react-toastify';
import { formSubmissionToast } from 'helpers/utils';
import { getTenantFromToken } from 'utils/routeUtils';

const HarvestForm = () => {
  const tenant = getTenantFromToken();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [tittle, setTittle] = useState('');
  const { id } = useParams();
  const edit = false;

  const fetchFormData = async () => {
    try {
      const formResponse = await cultivationApi.getHarvestForm(id, edit);
      setData(formResponse.data.results);
    } catch (error) {
      console.error('Error fetching form data:', error);
    }
  };

  useEffect(() => {
    fetchFormData();
  }, [tenant]);

  const header = (
    <div className="d-flex align-items-center">
      <div
        className="me-2 my-auto theme-control-toggle"
        onClick={() => navigate(`/${tenant}/cultivationReport`)}
      >
        <div className="theme-control-toggle-label">
          <FontAwesomeIcon icon={faArrowLeft} className="fs-0" />
        </div>
      </div>
      <span>{data?.form?.title}</span>
    </div>
  );

  const handleFormSubmit = async formData => {
    let formatedData = {
      ...formData
    };
    try {
      const response = await cultivationApi.updateHarvestForm(id, formatedData);

      // navigate(`/${tenant}/farmerReport/`);
      formSubmissionToast(response, toast, 'Harvest', edit);
      navigate(`/${tenant}/cultivationReport/`);
    } catch (err) {
      formSubmissionToast(err, toast, 'Harvest', edit);
    }
  };

  return (
    <Container>
      <Row>
        <Card className="mb-3">
          <Card.Header>
            <FalconCardHeader
              title={header}
              className="ps-lg-4"
              titleTag="h5"
              titleClass="mb-0"
              light
            />
          </Card.Header>
          <Card.Body>
            {!isEmpty(data) && (
              <DynamicForm
                data={data}
                header={true}
                onSubmit={handleFormSubmit}
              />
            )}
          </Card.Body>
        </Card>
      </Row>
    </Container>
  );
};

HarvestForm.propTypes = {
  edit: PropTypes.bool
};

export default HarvestForm;
